export class DocuSignTemplateModel{
    EngagementId: number;
    HDVariableName: string;
    Value: string;
    templateId: string;
}

export class DocuSignTemplateList{
    TemplateId: string;
}